import { useQuery } from 'react-query'
import useAxios from './useAxios'

const figures = [
	{ figure: '1 206 ', label: 'tonnes d’objets collectés' },
	{ figure: '682 238 ', label: 'objets sauvés' },
	{ figure: '85', label: 'salariés accompagnés' },
	{ figure: '515', label: 'ateliers comptants 4 160 participants' },
	{ figure: '4 227', label: 'créations artisanales' },
]
const list = ['Animations', 'Ameublement / Aménagement / Upcycling']

const itemData = [
	{
		img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
		title: 'L’équipe Ubisoft. ',
		author: '@bkristastucchio',
		featured: true,
	},
	{
		img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
		title: 'L’équipe Ubisoft a participé à notre atelier de couture Pnouf. ',
		author: '@rollelflex_graphy726',
	},
	{
		img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
		title: 'L’équipe Ubisoft a participé à notre atelier de couture Pnouf. ',
		author: '@helloimnik',
	},
	{
		img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
		title: 'Coffee',
		author: '@nolanissac',
	},
	{
		img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
		title: 'Hats',
		author: '@hjrc33',
	},
]

const useBenefit = () => {
	const { getBenefit } = useAxios()
	const { isLoading, data } = useQuery('prestationsPage', getBenefit)

	if (isLoading) return { isLoading }

	const { title, content } = data

	return {
		isLoading,
		title,
		content,
		list,
		figures,
		itemData,
	}
}

export default useBenefit
